import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-banners sf-banners--hero px-4 sm:px-0 sm:pb-8"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "sf-banners sf-banners--hero animate-pulse px-4 sm:px-0 sm:pb-8"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sf-banners__hero-wrapper sf-skeleton w-full mb-10" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "home__banners sf-banners sf-banners--carousel pl-4 sm:pl-0 sm:pb-8"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "home__banners sf-banners sf-banners--carousel animate-pulse pl-4 sm:pl-0 sm:pb-8"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "sf-skeleton img-skeleton rounded-2xl" }, null, -1)

import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import { Pagination, FreeMode, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import axiosClient from '@/api/axios'
import { restaurant, categories, apiBaseUrl, appliedCoupon } from '@/global/state/GlobalState'
import { BannersSection } from '@/global/state/StorefrontState'

/* global defineProps, defineEmits */

export default /*#__PURE__*/_defineComponent({
  __name: 'BannersSection',
  props: {
    section: {}
  },
  emits: ['open-product'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const modules = [Pagination, FreeMode, Autoplay]
const router = useRouter()
const toast = useToast()

const isHero = computed(() => props.section.settings?.style === 'hero')

const carouselBreakpoints = { 0: { slidesPerView: 1.13, spaceBetween: 0 }, 430: { slidesPerView: 1.3, spaceBetween: 10 }, 500: { slidesPerView: 1.3, spaceBetween: 20 }, 680: { slidesPerView: 1.7, spaceBetween: 20 }, 830: { slidesPerView: 2, spaceBetween: 20 }, 1050: { slidesPerView: 2.5, spaceBetween: 20 }, 1200: { slidesPerView: 3, spaceBetween: 20 } }

const isMobile = ref(window.matchMedia('(max-width: 768px)').matches)
const updateIsMobile = () => {
  isMobile.value = window.matchMedia('(max-width: 768px)').matches
}

const filteredBanners = computed<any[]>(() => {
  if (!restaurant.value.banners?.length) return []
  return restaurant.value.banners.filter((banner: any) => {
    if (!banner.deviceType || banner.deviceType === 'all') return true
    return isMobile.value ? banner.deviceType === 'mobile' : banner.deviceType === 'desktop'
  })
})

const getBannerImage = (banner: any) => {
  if (banner.source?.startsWith('http')) return banner.source
  return `${apiBaseUrl}/storage/${banner.source}`
}

const handleBannerClick = async (banner: any) => {
  if (!banner.actionType || !banner.actionValue) return
  if (banner.actionType === 'category') {
    router.push({ name: 'categories.show', params: { id: banner.actionValue } })
  } else if (banner.actionType === 'product') {
    const product = categories.value?.flatMap((c: any) => c.products || []).find((p: any) => p.id == banner.actionValue)
    if (product) emit('open-product', product)
  } else if (banner.actionType === 'coupon') {
    try {
      const response = await axiosClient.get(`customer/coupons/${banner.actionValue}`)
      appliedCoupon.value = response.data
      toast.success(`Cupom ${response.data.code} aplicado!`)
    } catch (error) {
      console.error('Erro ao aplicar cupom do banner:', error)
      toast.error('Cupom inválido ou expirado')
    }
  }
}

onMounted(() => window.addEventListener('resize', updateIsMobile))
onUnmounted(() => window.removeEventListener('resize', updateIsMobile))

return (_ctx: any,_cache: any) => {
  return (isHero.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (filteredBanners.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(Swiper), {
                "slides-per-view": 1,
                "space-between": 0,
                pagination: { clickable: true },
                autoplay: filteredBanners.value.length > 1 ? { delay: 5000, disableOnInteraction: false } : false,
                loop: filteredBanners.value.length > 1,
                modules: modules,
                class: "pb-10"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBanners.value, (banner) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      key: banner.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["sf-banners__hero-wrapper w-full overflow-hidden", { 'cursor-pointer': banner.actionType }]),
                          onClick: ($event: any) => (handleBannerClick(banner))
                        }, [
                          _createElementVNode("img", {
                            class: "w-full h-full object-cover",
                            src: getBannerImage(banner),
                            alt: ""
                          }, null, 8, _hoisted_3)
                        ], 10, _hoisted_2)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["autoplay", "loop"])
            ]))
          : _createCommentVNode("", true),
        (!_unref(restaurant).id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (filteredBanners.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_unref(Swiper), {
                "slides-per-view": 3,
                "space-between": 50,
                pagination: true,
                modules: modules,
                breakpoints: carouselBreakpoints,
                "free-mode": true,
                class: "pb-10"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBanners.value, (banner) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      class: "pr-4 sm:p-0",
                      key: banner.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "home__banners__wrapper w-full rounded-xl cursor-pointer",
                          onClick: ($event: any) => (handleBannerClick(banner))
                        }, [
                          _createElementVNode("img", {
                            style: {"perspective":"1px"},
                            class: "w-full img-skeleton rounded-2xl object-fill",
                            src: getBannerImage(banner),
                            alt: ""
                          }, null, 8, _hoisted_9)
                        ], 8, _hoisted_8)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_unref(restaurant).id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_unref(Swiper), {
                "slides-per-view": 3,
                "space-between": 50,
                pagination: true,
                modules: modules,
                breakpoints: carouselBreakpoints,
                "free-mode": true,
                class: "pb-10"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3], (i) => {
                    return _createVNode(_unref(SwiperSlide), {
                      class: "pr-4 sm:p-0",
                      key: i
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 2
                    }, 1024)
                  }), 64))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 64))
}
}

})